const actions = {
    SALES_INVOICE_DETAILS_START: 'SALES_INVOICE_DETAILS_START',
    SALES_INVOICE_DETAILS_SUCCESS: 'SALES_INVOICE_DETAILS_SUCCESS',
    SALES_INVOICE_DETAILS_FAILURE: 'SALES_INVOICE_DETAILS_FAILURE',

    SALES_TRANSACTION_DETAILS_START: 'SALES_TRANSACTION_DETAILS_START',
    SALES_TRANSACTION_DETAILS_SUCCESS: 'SALES_TRANSACTION_DETAILS_SUCCESS',
    SALES_TRANSACTION_DETAILS_FAILURE: 'SALES_TRANSACTION_DETAILS_FAILURE',

    CLEAR_SALES_TRANSACTION_DETAILS_START: 'CLEAR_SALES_TRANSACTION_DETAILS_START',
    CLEAR_SALES_TRANSACTION_DETAILS_SUCCESS: 'CLEAR_SALES_TRANSACTION_DETAILS_SUCCESS'
};

export default actions;